export const isFallow = (val: string) =>
  val === 'fallow' || val === 'winterFallow' || val === 'preventPlant'
